//初回レンダリング時ログインされいため、ログインユーザを取得不可。そのため、ログインしてから初回レンダリングを実施する。
import React from "react";
import D3Point from '../d3Point.js';
function WrapPoint() {
  return (
    <D3Point/>
  );
}
export default WrapPoint;
